import { useState, useEffect } from "react";

export function useElementSize({ ref, selector }) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    let el = null;

    if (ref?.current && selector) {
      // selector inside ref
      el = ref.current.querySelector(selector);
    } else if (ref?.current) {
      // just ref
      el = ref.current;
    } else if (selector) {
      // just selector
      el = document.querySelector(selector);
    } else {
    }

    if (!el) return;

    const updateSize = () => {
      setSize({
        width: el.clientWidth,
        height: el.clientHeight,
      });
    };

    updateSize();

    const observer = new ResizeObserver(updateSize);
    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, [ref, selector]);

  return size;
}
